import styles from './DashboardItem.less';

import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'seek-style-guide/react';

export default class DashboardItem extends Component {
  static propTypes = {
    heading: PropTypes.func.isRequired,
    subheading: PropTypes.func.isRequired,
    count: PropTypes.func
  };

  static defaultProps = {
    count: null
  };

  render() {
    const { heading, subheading, count } = this.props;
    const showCount = count !== null;
    const className = classnames({
      [styles.root]: true,
      [styles.root_hasCount]: showCount
    });

    return (
      <div className={className}>
        <Text raw small className={styles.truncate}>
          {heading()}
        </Text>
        <Text secondary raw small className={styles.truncate}>
          {subheading()}
        </Text>
        {showCount && (
          <Text raw small className={styles.count}>
            {count()}
          </Text>
        )}
      </div>
    );
  }
}
